import { Docs, LogisticaManifiestoProformaEstado, estadoLogisticaManifiestoProformaDetalle } from "@pcgerente-node/pcg-comun"
import { logistica_GUIA_PROFORMA, logistica_MANIFIESTO_PROFORMA, logistica_MANIFIESTO_PROFORMA_DETALLE, logistica_RANGO_GUIA } from "@pcgerente-node/pcg-comun/dist/DTOs"
import axios, { AxiosResponse } from "axios"
import { useEffect, useState } from "react"
import { useCookies } from "react-cookie"
import { MdRestartAlt } from "react-icons/md"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { getAllCities, obtenerGuiasProformasLiberadas, obtenerRangoGuiaDelUsuario } from "../../../redux/actions/actionsCrear"
import { baseURL, handleResponse, headers } from "../../../redux/helpersRedux"
import { RootState, useAppDispatch } from "../../../redux/store"
import {IApiResponse} from "@pcgerente-node/pcg-comun";
import Loading from "../../helpers/Loading/Loading"
import OpcionesCamposGuia from "./OpcionesCamposGuia"
import Paged from "./Paged/PagedCrearResumenGuia"
import { StyleProps1, StyleProps2, StyleProps6, StyleProps8 } from "./stylesCrearResumenGuia"

const CrearResumenGuiaContent = () => {
    const [cookiesLocal] = useCookies(['idUsuario'])

    const InitialState: logistica_GUIA_PROFORMA[] = []
    const InitialStateCampos: ("Numero de bultos" | "Numero de Kg")[] = ["Numero de Kg", "Numero de bultos"]

    const [guiasSeleccionadas, setGuiasSeleccionadas] = useState(InitialState)
    const [camposSeleccionados, setCamposAdicionales] = useState(InitialStateCampos)
    const [observacion, setObservacion] = useState("")

    //Manejo respuesta
    const [error, setError] = useState("")
    const [success, setSuccess] = useState(false)

    const guiasProformaDB = useSelector((state: RootState) => state.crear.guiasProformaDB)
    const usuarioDB = useSelector((state: RootState) => state.auth.usuarioActual)
    const rangoGuiaStore = useSelector((state: RootState) => state.crear.rangoGuia)
    const dispatch = useAppDispatch()

    let fechaActualFormateada = new Date().toISOString()
    fechaActualFormateada = fechaActualFormateada.slice(0, fechaActualFormateada.indexOf("T"))

    let fechaAnterior = new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString()
    fechaAnterior = fechaAnterior.slice(0, fechaAnterior.indexOf("T"));

    const queryEstadoInicial = {
        desde: fechaAnterior,
        hasta: fechaActualFormateada,
        error: ""
    }
    const [query, setQuery] = useState(queryEstadoInicial)

    useEffect(() => {
        dispatch(getAllCities())
        buscarGuias()
        dispatch(obtenerRangoGuiaDelUsuario(usuarioDB._ItemActivo.id, Docs.GUIA_TRANSPORTE))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        rangoGuiaStore.errorUndefined ?
            <div id="content" className="main-content">
                <h3 className="mt-4 text-danger p-4 text-center">
                    {rangoGuiaStore.errorUndefined}
                </h3>
            </div>
            :
            <div id="content" className="main-content">
                <div className="layout-px-spacing">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="col-sm-12 text-center">
                            <h3 style={StyleProps1}>Crear Resumen de Guías</h3>
                        </div>
                        <div className="col-sm-12 text-center">
                            <form className="form-inline" onSubmit={(e) => e.preventDefault()}>
                                <div className="input-group mb-2 mr-sm-2 col-sm-4">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text" style={StyleProps2}>Desde</div>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="date"
                                            placeholder=""
                                            value={query.desde}
                                            onChange={(e) => handleQuery(e, "desde")}
                                        />
                                    </div>
                                </div>
                                <div className="input-group mb-2 mr-sm-2 col-sm-5">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text" style={StyleProps2}>Hasta</div>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="date"
                                            placeholder=""
                                            value={query.hasta}
                                            onChange={(e) => handleQuery(e, "hasta")}
                                        />
                                    </div>
                                </div>
                                <div className="input-group mb-2 mr-sm-2 col-sm d-flex justify-content-center">
                                    <button onClick={() => restablecerFiltrado()} className="btn btn-danger mt-1 mb-1" style={StyleProps8}>
                                        <MdRestartAlt />
                                    </button>

                                    <button onClick={() => buscarGuias()} className="btn btn-primary mt-1 mb-1">Buscar</button>
                                </div>
                                <label>{query.error}</label>
                            </form>
                        </div>
                    </div>
                    <div id="contenedor-tabla-resumen-guia">
                        <div className="col-xl-12 col-lg-16 col-md-12 col-sm-12 col-12 layout-spacing">
                            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                                <div className="br-6">
                                    {guiasProformaDB.info.length > 0 ?
                                        <>
                                            {/* Maneja que se vean los campos de kg y numero de bultos */}
                                            <OpcionesCamposGuia
                                                handleSeleccionarCampo={handleSeleccionarCampo}
                                                camposSeleccionados={camposSeleccionados}
                                            />

                                            <Paged
                                                guiasProforma={guiasProformaDB.info}
                                                guiasSeleccionadas={guiasSeleccionadas}
                                                handleSeleccionarGuia={handleSeleccionarGuia}
                                                seleccionarTodasLasGuias={seleccionarTodasLasGuias}
                                                camposSeleccionados={camposSeleccionados}
                                            />
                                        </>

                                        : <div className="d-flex justify-content-center ">
                                            {guiasProformaDB.loading ?
                                                <Loading />
                                                : <span className="text-center text-danger mt-1 mb-1">No hay guias proformas disponibles para crear un resumen de guias</span>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="invoice-detail-note">
                                <div className="row">
                                    <div className="col-md-12 align-self-center">
                                        <div className="form-group row invoice-note">
                                            <label htmlFor="invoice-detail-notes" className="col-sm-12 col-form-label col-form-label-sm">Observación:</label>
                                            <div className="col-sm-12">
                                                <textarea
                                                    className="form-control"
                                                    id="invoice-detail-notes"
                                                    maxLength={100}
                                                    style={StyleProps6}
                                                    value={observacion}
                                                    onChange={(e) => setObservacion(e.target.value)}
                                                    disabled={guiasSeleccionadas.length === 0}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="invoice-action-btn">
                                <div className="row">
                                    <div className="col-sm-12 text-center">
                                        {!success ?
                                            <button
                                                disabled={error.length > 0 || guiasSeleccionadas.length === 0 ? true : false}
                                                onClick={() => handleSumbit()}
                                                className="btn btn-primary btn-send"
                                                id="btnGuardar"
                                            >
                                                Guardar
                                            </button>
                                            :
                                            <Link to={"/home/consulta/resumenGuias"}>
                                                <button className="btn btn-success btn-send">Ver Resumen de Guias</button>
                                            </Link>
                                        }
                                    </div>
                                </div>
                            </div>
                            <label> Guias Seleccionadas: {guiasSeleccionadas.length}</label>
                            <div >
                                {!success ?
                                    <label className="text-danger">{error}</label>
                                    : <label className="text-success">Se ha creado un nuevo Resumen de Guias</label>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

    )


    async function handleSumbit() {
        const btnGuardar = window.document.getElementById('btnGuardar') as HTMLButtonElement | null;
        try {
            if (btnGuardar) {
                btnGuardar.disabled = true
                const rangoGuia = await axios(`${baseURL}logistica_RANGO_GUIA?idUsuario=${usuarioDB._ItemActivo.id}&idDocumento=${Docs.GUIA_TRANSPORTE}`, headers)
                .then((res: AxiosResponse<IApiResponse<logistica_RANGO_GUIA>>) => handleResponse(res))
                
                const infoToSubmit: logistica_MANIFIESTO_PROFORMA = {
                    serie1: rangoGuia.serie1,
                    serie2: rangoGuia.serie2,
                    numeroDocumento: rangoGuia.numero,
                    idUsuario: usuarioDB._ItemActivo.id,
                    fechaEmision: new Date(),
                    idDocumento: Docs.GUIA_TRANSPORTE,
                    LS_usuarioCreacion: usuarioDB._ItemActivo.usuario,
                    estado: LogisticaManifiestoProformaEstado.Pendiente,
                    idCiudadOrigen: guiasSeleccionadas[0].idCiudadOrigen,
                    idCiudadDestino: guiasSeleccionadas[0].idCiudadDestino,
                    observacion: observacion.trim(),
                    logistica_MANIFIESTO_PROFORMA_DETALLE: convertirGuiasSeleccionadasEnDetalles(guiasSeleccionadas)
                }
                const post: AxiosResponse<IApiResponse<logistica_MANIFIESTO_PROFORMA>> = await axios.post(`${baseURL}logistica_MANIFIESTO_PROFORMA`, infoToSubmit, headers)
                if (!post.data.success) {
                    throw new Error(`No se ha podido podido crear el manifiesto. Ha aparecido el error: ${post.data.message}`)
                } else {
                    setObservacion("")
                    setSuccess(true)
                }
                
            }
        } catch (error) {
            if(error instanceof Error)
                setError(error.message)        
        }finally{
            if(btnGuardar)
                btnGuardar.disabled = false
        }
    }
        
        //funciones
        function handleQuery(e: React.ChangeEvent<HTMLInputElement>, type: string) {
            if (type === "desde") {
                setQuery({
                    ...query,
                    desde: e.target.value
                })
        }
        if (type === "hasta") {
            setQuery({
                ...query,
                hasta: e.target.value
            })
        }
    }

    function buscarGuias() {
        dispatch(obtenerGuiasProformasLiberadas(query.desde, query.hasta, usuarioDB._ItemActivo.id))
    }
    function restablecerFiltrado() {
        setQuery(queryEstadoInicial)
    }

    function handleSeleccionarGuia(guia: logistica_GUIA_PROFORMA) {
        //Agregamos o quitamos las guias seleccionadas
        if (guiasSeleccionadas.includes(guia)) {
            setGuiasSeleccionadas(guiasSeleccionadas.filter((el) => el !== guia));
        } else {
            setGuiasSeleccionadas([...guiasSeleccionadas, guia]);
        }
    };

    function handleSeleccionarCampo(campo: "Numero de bultos" | "Numero de Kg") {
        //Agregamos o quitamos los campos que le llegan
        if (camposSeleccionados.includes(campo)) {
            setCamposAdicionales(camposSeleccionados.filter((el) => el !== campo));
        } else {
            setCamposAdicionales([...camposSeleccionados, campo]);
        }
    };

    function seleccionarTodasLasGuias() {
        setGuiasSeleccionadas(guiasProformaDB.info);
    };

    function convertirGuiasSeleccionadasEnDetalles(guiasProformas: logistica_GUIA_PROFORMA[]): logistica_MANIFIESTO_PROFORMA_DETALLE[] {
        let retorno: logistica_MANIFIESTO_PROFORMA_DETALLE[] = []
        for(const g of guiasProformas){
                const det = new logistica_MANIFIESTO_PROFORMA_DETALLE()  
                det.estado= "P" as estadoLogisticaManifiestoProformaDetalle
                det.observaciones= ""
                det.idGuiaProforma= g.id??0
                retorno.push(det)
        }
        return retorno
    }
}


export default CrearResumenGuiaContent